<template>
    <v-container fluid fill-height class="login-container">
        <Headful title="Inloggen"></Headful>
        <Header
            color="white"
            extended
            show-logo
            show-back-button
            :dark="false"
        ></Header>
        <v-layout align-center justify-center class="flex-fill">
            <v-flex>
                <v-form ref="form" @submit.prevent="checkLogin">
                    <v-card class="elevation-0 login-card">
                        <v-card-text>
                            <h1 class="text-h5 mt-3 mb-4 text-center text--success">Voer hier je inloggegevens in</h1>
                            <p>Direct naar het overzicht van dienstverleners of naar de profielen, voer hier je inloggegevens in.
                                Inloggegevens worden verstrekt door je leidinggevende of via de onderwijsregio.</p>
                            <v-text-field
                                type="email"
                                outlined
                                rounded
                                hide-details="auto"
                                single-line
                                v-model="username"
                                label="E-mailadres"
                                :rules="usernameRules"
                                required
                                class="mb-2"
                            ></v-text-field>
                            <v-text-field
                                type="password"
                                outlined
                                rounded
                                hide-details="auto"
                                single-line
                                v-model="password"
                                label="Wachtwoord"
                                :rules="passwordRules"
                                required
                                class="mb-5"
                            ></v-text-field>
                            <v-checkbox
                                label="Ingelogd blijven"
                                v-model="rememberMe"
                            ></v-checkbox>
                            <v-btn type="submit" color="primary" block rounded :loading="submitting" :disabled="submitting || username.length < 1 || password.length < 1" class="mb-2 elevation-0">Inloggen</v-btn>
                            <v-btn @click="openForgotPassword" text block rounded color="secondary">Wachtwoord vergeten?</v-btn>
                            <!-- Medewerkers zonder account kunnen zich hier zelf aanmelden voor opname in het mobiliteitsportaal. -->
                            <v-divider class="my-5"></v-divider>
                            <p class="text-center mb-3">Wil je zelf opgenomen worden in het mobiliteitsportaal?</p>
                            <v-btn :to="{ name: 'RegisterProfile' }" color="secondary" outlined block rounded class="elevation-0">
                                <v-icon left small>fal fa-user-plus</v-icon>
                                Aanmelden voor het mobiliteitsportaal
                            </v-btn>
                        </v-card-text>
                    </v-card>
                </v-form>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
import Headful from "@/components/layout/Headful";
import Header from "@/components/layout/Header";

export default {
    name: "SignIn",
    components: {
        Headful,
        Header
    },
    data: () => ({
        submitting: false,
        username: '',
        usernameRules: [
            v => !!v || 'E-mailadres is verplicht'
        ],
        password: '',
        passwordRules: [
            v => !!v ||'Wachtwoord is verplicht'
        ],
        rememberMe: false,
    }),
    mounted () {
        if (this.$store.state.auth.isLoggedIn) {
            this.$router.push({name: "Home"});
        }
    },
    methods: {
        openForgotPassword () {
            this.$router.push({name: "ForgotPassword"})
        },
        checkLogin () {
            // Check if form is valid
            if (!this.$refs.form.validate()) {
                return;
            }

            this.submitting = true;

            // Submit data to auth store
            this.$store.dispatch('login', {
                username: this.username,
                password: this.password,
                _remember_me: this.rememberMe,
            }).then((success) => {
                if (success) {
                    this.$router.push({name: "Home"})
                } else {
                    return this.$store.dispatch('showSnackbar', { color: 'error', text: 'Ongeldige inloggegevens'});
                }
            }).catch((e) => {
                console.error(e);
                return this.$store.dispatch('showSnackbar', { color: 'error', text: 'Ongeldige inloggegevens' });
            }).finally(() => {
                this.submitting = false;
            });
        },
    },
}
</script>

<style scoped>
.v-card .v-card__text {
    max-width: 600px;
    margin: 0 auto;
}

.login-card .v-card__text {
    max-width: 500px;
}
</style>
